const initialState = {
  ids: [],
  byId: {},
};

const reductions = {
  NEW_BOT_TAG: function (state, action) {
    const tag = action.payload;
    const newIds = [].concat(state.ids);
    if (!newIds.includes(tag.id)) {
      newIds.push(tag.id);
    }
    const newById = Object.assign({}, state.byId, { [tag.id]: tag });
    return {
      ids: newIds,
      byId: newById,
    };
  },
  UPDATE_BOT_TAG: function (state, action) {
    const tag = action.payload;
    const newIds = [].concat(state.ids);
    if (!newIds.includes(tag.id)) {
      newIds.push(tag.id);
    }
    const newById = Object.assign({}, state.byId, { [tag.id]: tag });
    return {
      ids: newIds,
      byId: newById,
    };
  },
  DELETE_BOT_TAG: function (state, action) {
    const tag = action.payload;
    const newIds = state.ids.filter((id) => id !== tag.id);
    const newById = Object.assign({}, state.byId);
    delete newById[tag.id];
    return {
      ids: newIds,
      byId: newById,
    };
  },
  NEW_BOT_TAGS: function (state, action) {
    const tags = action.payload;
    const newIds = [].concat(state.ids);
    const newById = Object.assign({}, state.byId);
    tags.forEach((tag) => {
      if (!newIds.includes(tag.id)) {
        newIds.push(tag.id);
      }
      newById[tag.id] = tag;
    });
    return {
      ids: newIds,
      byId: newById,
    };
  },
  REPLACE_BOT_TAGS: function (_state, action) {
    const tags = action.payload;
    const ids = [];
    const byId = {};
    tags.forEach((tag) => {
      ids.push(tag.id);
      byId[tag.id] = tag;
    });
    return {
      ids,
      byId,
    };
  },
};

const botTagsReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default botTagsReducer;
